
export function slideInColumns() {
    const columns = document.querySelectorAll(".is-style-fade-in");

    const mq = window.matchMedia("(min-width: 980px)");
    const thresholdValue = mq.matches ? 0.8 : 0.2;

    const slideInColumn = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add("show");
            } else {
                entry.target.classList.remove("show");
            }
        });
    }, {
        threshold: thresholdValue,
        rootMargin: "0px"
    });

    columns.forEach(col => slideInColumn.observe(col));

}